import { render, staticRenderFns } from "./basic-text-visualizer.vue?vue&type=template&id=625d07bf&scoped=true&"
import script from "./basic-text-visualizer.vue?vue&type=script&lang=js&"
export * from "./basic-text-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./basic-text-visualizer.vue?vue&type=style&index=0&id=625d07bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d07bf",
  null
  
)

export default component.exports